<template>
  <!-- 系统配置-洗美项目 -->
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input
                style="width: 200px"
                placeholder="项目名称"
                size="small"
                v-model="search.keyWord"
                @change="clickSearch"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- projectType 1 洗澡 2美容 3 单项服务 -->
          <el-col :span="4">
            <el-form-item label="项目类型">
              <el-select
                style="width: 140px"
                size="small"
                class="select"
                v-model="search.projectType"
                placeholder="请选择"
                @change="clickSearch"
              >
                <el-option
                  v-for="item in [
                    { value: 1, label: '洗澡' },
                    { value: 2, label: '美容' },
                    { value: 3, label: '单项服务' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="适用宠物">
              <el-select
                style="width: 140px"
                size="small"
                class="select"
                v-model="search.petType"
                placeholder="请选择"
                @change="clickSearch"
              >
                <el-option
                  v-for="item in petList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="参与门店">
              <el-select
                style="width: 140px"
                size="small"
                class="select"
                v-model="search.shopId"
                placeholder="请选择"
                @change="clickSearch"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
          <el-col :span="4" style="line-hight: 41px; height: 41px">
            <el-button
              style="margin-top: 5px"
              type="warning"
              size="mini"
              @click="configWeight"
              >体重配置
            </el-button>
            <el-button
              style="margin-top: 5px"
              type="warning"
              size="mini"
              @click="$router.push({ path: '/ximeiyuyue/yuyuePeiZhiAdd' })"
              >新建预约配置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="pageConBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="分类" prop="projectType.name">
        </el-table-column>
        <el-table-column label="适用宠物">
          <template slot-scope="scope">
            <span v-for="item in scope.row.fitPetList" :key="item.id">
              <span>{{ item.name }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" prop="projectName"> </el-table-column>
        <el-table-column label="参与门店">
          <template slot-scope="scope">
            <span v-for="item in scope.row.shopList" :key="item.id"
              >{{ item.shopName }},</span
            >
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{ scope.row.state == "1" ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button @click="see(scope.row)" type="text" size="small"
              >查看</el-button
            > -->
            <el-button type="text" size="small" @click="UpdateConfig(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="delConfig(scope.row)"
              >删除</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="UpdateConfigState(scope.row)"
            >
              {{ scope.row.state == "1" ? "禁用" : "启用" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination
          background
          @current-change="changePage"
          :current-page="page.page"
          :page-size="page.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 体重配置列表 -->
    <div v-if="configWeight_state">
      <configWeight @submit="submit_drawerWeight"></configWeight>
    </div>
  </div>
</template>

<script>
import resetBtn from "../../../components/resetBtn.vue";
import configWeight from "./drawer_weight.vue";
export default {
  components: {
    resetBtn,
    configWeight,
  },
  data() {
    return {
      petList: [
        {
          id: "1",
          name: "猫猫",
        },
        {
          id: "2",
          name: "狗狗",
        },
        {
          id: "3",
          name: "异宠",
        },
      ],
      // 搜索内容
      search: {
        name: "",
        petType: "", //宠物列表 宠物列表 1 猫 2狗 3异宠
        keyWord: "",
        shopId: "",
        projectType: "", //项目类型  1 洗澡 2美容 3 单项服务
      },
      configWeight_state: false, //体重配置
      shopList: this.$store.state.myShopList,
      // 分页
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 数据列表
      tableData: [],
      state: 0, //状态
    };
  },
  computed: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    // 修改配置
    UpdateConfig(a) {
      let query = {
        id: a.id,
        type: 1,
      };
      this.$router.push({
        path: "/ximeiyuyue/yuyuePeiZhiEdit",
        query,
      });
    },
    // 修改配置状态
    UpdateConfigState(a) {
      if (a.state == 1) {
        this.state = 2;
      } else {
        this.state = 1;
      }
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/Resvere/UpdateConfigState", {
          id: a.id,
          state: this.state,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log('修改状态',res);
            this.getTableData();
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
          }
        });
    },
    // 删除配置
    delConfig(info) {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/Resvere/DeleteConfig", {
          id: info.id,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log('删除',res);
            this.getTableData();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
    },
    // 体重配置
    configWeight() {
      this.configWeight_state = true;
    },
    submit_drawerWeight() {
      this.configWeight_state = false;
    },
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyWord: this.search.keyWord,
        projectType: this.search.projectType - 0, //项目类型  1 洗澡 2美容 3 单项服务
        petType: this.search.petType - 0, //宠物列表 宠物列表 1 猫 2狗 3异宠
        shopId: this.search.shopId,
        state: 0, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          console.log("预约配置列表", res);
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    reset() {
      this.search.keyWord = "";
      this.search.projectType = "";
      this.search.petType = "";
      this.search.shopId = "";
      this.page.page = 1;
      this.getTableData();
    },
    clickSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    see() {},
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .pageConBox {
    padding: 0 20px;
    min-height: 600px;
    margin-top: 10px;
  }
}
</style>
